import React from 'react';
import { type SubscriptionVariant } from '../../lib/types';

type CartTablePriceCellProps = {
  readonly price: string;
  readonly subscription: SubscriptionVariant;
};

export function CartTablePriceCell(props: CartTablePriceCellProps) {
  if (props.subscription === 'annual' || props.subscription === 'biannual') {
    const monthsPrepaid = props.subscription === 'biannual' ? 6 : 12;
    const priceAsNumber = Number.parseFloat(props.price);
    const pricePerMonth = priceAsNumber / monthsPrepaid;
    return (
      <>
        <p>€{props.price}</p>
        <p className="text-warning-orange">
          ({pricePerMonth} * {monthsPrepaid})
        </p>
      </>
    );
  }

  return <p>€{props.price}</p>;
}
